module.exports = __webpack_public_path__ + "static/media/list-chart.923a30d2.svg";